module.exports = __webpack_public_path__ + "img/CHIPS.GG.45ca4248.svg";